import type { ApiKey } from "./api-keys.types";

export type EffectiveStatus = "active" | "revoked" | "expired";

// Display status. Backend only tracks active/revoked, so expiry is layered on
// top here: a non-revoked key past its expiry reads as "expired". A key issued
// without an expiry has no date to be past.
export function effectiveStatus(key: ApiKey): EffectiveStatus {
	if (key.status === "revoked") return "revoked";
	if (!key.expiresAt) return "active";
	if (new Date(key.expiresAt).getTime() <= Date.now()) return "expired";
	return "active";
}

// The name the server gives every connection it creates.
export const CONNECTION_PREFIX = "MCP: ";

// The API deploys apart from the platform, so a row can lack `connection`. The server's own name
// for a connection is the best sign then.
export function isConnection(key: ApiKey): boolean {
	return key.connection ?? key.name?.startsWith(CONNECTION_PREFIX) === true;
}
